@use "../../styles/breakpoint.module.scss" as *;

// ── Root ──

.root {
    composes: themed from "../../styles/themes.module.scss";
    composes: grid from "../../styles/layout.module.scss";
    grid-column: 1 / -1;
    width: 100%;
}

// ── Callout (centered) ──

.callout {
    > .content {
        grid-column: content;
        display: grid;
        grid-template-columns: subgrid;
        text-align: center;
        align-items: start;

        > * {
            grid-column: 1 / -1;
        }
    }

    .heading {
        grid-column: col-start 2 / span 10;

        @media ($below-tablet) {
            grid-column: content;
        }
    }

    .body,
    .form {
        grid-column: col-start 4 / span 6;

        @media ($below-tablet) {
            grid-column: col-start 2 / span 10;
        }

        @media ($below-mobile) {
            grid-column: content;
        }
    }
}

// ── Media (split) ──

.media {
    .imageWrapper {
        grid-column: col-start 1 / span 6;
        aspect-ratio: 3 / 2;
        margin-top: auto;

        @media ($below-tablet) {
            grid-column: content;
            grid-row: 2;
            max-width: 60%;
            justify-self: center;
        }
    }

    > .content {
        grid-column: col-start 7 / span 6;
        align-self: center;
        padding-block: var(--spacer-80);

        @media ($below-tablet) {
            grid-column: content;
            grid-row: 1;
            padding-block-end: 0;
        }
    }
}

// ── Shared ──

.content {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-24);
}

.heading {
    composes: fontHB80 from "../../styles/typography.module.scss";
}

.body {
    composes: fontP20 from "../../styles/typography.module.scss";
}

.image {
    object-fit: contain;
}

.form {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-16);
}

.input {
    // Filled field so the signup stands out on any module theme. Text is
    // pinned to black because the fill is always white.
    --color-text: var(--black);

    margin-bottom: var(--spacer-16);

    input {
        background: var(--white);
        color: var(--black);
        padding-inline: var(--spacer-16);
        padding-block-start: var(--spacer-24);
        border-radius: var(--border-radius-sm);
    }

    // The fill already marks the field, so drop the resting underline. Less
    // specific than the shared invalid rule, which still turns it red.
    div:has(> input) {
        border-bottom-color: transparent;
    }

    // Shifted to match the fill's padding, so the floating label sits
    // inside the box rather than on its edge.
    label {
        left: var(--spacer-16);
        margin-top: var(--spacer-8);
    }
}

.checkbox {
    margin-bottom: var(--spacer-24);
}

.fieldset {
    display: contents;
}

.submitWrapper {
    margin-top: var(--spacer-8);
}

// Matches the footer signup's error style, with the same red fallback the
// form fields use when the theme doesn't set --color-invalid.
.error {
    composes: fontST16 from "../../styles/typography.module.scss";
    color: var(--color-invalid, var(--red));
}

// Focused from script so screen readers land on it, but it isn't a control,
// so it doesn't need a focus ring.
.success:focus {
    outline: none;
}

.successMessage {
    composes: fontSH24 from "../../styles/typography.module.scss";
}

.callout .form {
    align-items: stretch;
}

.callout .submitWrapper {
    align-self: center;
}
